export default __webpack_public_path__ + "media/images/top-onglet-c42dad0b500e57bddcd4fc7f943a88cb.png";